// import React, { useState } from "react";
// import "../css/Members.css";

// const DEMO_MEMBERS = [
//   {
//     id: 1,
//     name: "Ahmad Raza Najmuddin Ali",
//     profession: "Software Engineer",
//     role: "Technical Lead",
//     joined: "Jan 2023",
//     location: "Mumbai, MH",
//     bio: "Handles the foundation's digital infrastructure and tech initiatives.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=Ahmad Raza NajmuddinAli&backgroundColor=162f06",
//     tag: "Core Team",
//     tagColor: "#162f06",
//   },
//   {
//     id: 2,
//     name: "Zain Hussain",
//     profession: "Doctor (MBBS)",
//     role: "Medical Coordinator",
//     joined: "Feb 2023",
//     location: "Mumbai, MH",
//     bio: "Coordinates medical help requests and liaises with hospitals.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=ZainHussain&backgroundColor=2980b9",
//     tag: "Medical",
//     tagColor: "#2980b9",
//   },
//   {
//     id: 3,
//     name: "Abbas Mirza",
//     profession: "Civil Engineer",
//     role: "Infrastructure Head",
//     joined: "Jan 2023",
//     location: "Thane, MH",
//     bio: "Oversees construction and repair projects for underprivileged families.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=AbbasMirza&backgroundColor=8e44ad",
//     tag: "Core Team",
//     tagColor: "#162f06",
//   },
//   {
//     id: 4,
//     name: "Ali Mohammad",
//     profession: "Teacher (M.Ed)",
//     role: "Education Coordinator",
//     joined: "Mar 2023",
//     location: "Mumbai, MH",
//     bio: "Manages educational aid programs and scholarship distribution.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=AliMohammad&backgroundColor=e67e22",
//     tag: "Education",
//     tagColor: "#e67e22",
//   },
//   {
//     id: 5,
//     name: "Hussain Raza",
//     profession: "Chartered Accountant",
//     role: "Finance Manager",
//     joined: "Jan 2023",
//     location: "Mumbai, MH",
//     bio: "Manages funds, accounts, and ensures financial transparency.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=HussainRaza&backgroundColor=27ae60",
//     tag: "Finance",
//     tagColor: "#27ae60",
//   },
//   {
//     id: 6,
//     name: "Mahdi Khan",
//     profession: "Social Worker (MSW)",
//     role: "Outreach Coordinator",
//     joined: "Apr 2023",
//     location: "Navi Mumbai, MH",
//     bio: "Leads community outreach and identifies families in need.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=MahdiKhan&backgroundColor=c0392b",
//     tag: "Outreach",
//     tagColor: "#c0392b",
//   },
//   {
//     id: 7,
//     name: "Arsalan Sheikh",
//     profession: "Graphic Designer",
//     role: "Creative Director",
//     joined: "May 2023",
//     location: "Mumbai, MH",
//     bio: "Handles all design, branding, and social media creatives.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=ArsalanSheikh&backgroundColor=1abc9c",
//     tag: "Creative",
//     tagColor: "#1abc9c",
//   },
//   {
//     id: 8,
//     name: "Ali Mehdi",
//     profession: "Journalist (BA Media)",
//     role: "PR & Communications",
//     joined: "Jun 2023",
//     location: "Mumbai, MH",
//     bio: "Handles press releases, media relations, and public communications.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=AliMehdi&backgroundColor=2c3e50",
//     tag: "PR",
//     tagColor: "#2c3e50",
//   },
//   {
//     id: 9,
//     name: "Ali Abbas",
//     profession: "Pharmacist (B.Pharm)",
//     role: "Medicine Procurement",
//     joined: "Jul 2023",
//     location: "Mumbai, MH",
//     bio: "Sources medicines at subsidized rates for medical help beneficiaries.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=AliAbbas&backgroundColor=16a085",
//     tag: "Medical",
//     tagColor: "#2980b9",
//   },
//   {
//     id: 10,
//     name: "Fatima Zahra",
//     profession: "Nutritionist (B.Sc)",
//     role: "Ration & Food Aid",
//     joined: "Aug 2023",
//     location: "Mumbai, MH",
//     bio: "Plans and manages monthly ration distribution and nutrition programs.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=FatimaZahra&backgroundColor=d35400",
//     tag: "Ration",
//     tagColor: "#f39c12",
//   },
//   {
//     id: 11,
//     name: "Syed Raza",
//     profession: "Lawyer (LLB)",
//     role: "Legal Advisor",
//     joined: "Sep 2023",
//     location: "Mumbai, MH",
//     bio: "Provides legal guidance and handles NGO registration & compliance.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=SyedRaza&backgroundColor=6c3483",
//     tag: "Legal",
//     tagColor: "#6c3483",
//   },
//   {
//     id: 12,
//     name: "Maryam Naqvi",
//     profession: "Psychologist (M.Sc)",
//     role: "Welfare Counselor",
//     joined: "Oct 2023",
//     location: "Thane, MH",
//     bio: "Provides mental health counseling and psychosocial support to beneficiaries.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=MaryamNaqvi&backgroundColor=a93226",
//     tag: "Welfare",
//     tagColor: "#a93226",
//   },
//   {
//     id: 13,
//     name: "Hasan Mirza",
//     profession: "Logistics Manager",
//     role: "Volunteer Coordinator",
//     joined: "Nov 2023",
//     location: "Mumbai, MH",
//     bio: "Coordinates volunteer schedules, field visits, and sadqa box deliveries.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=HasanMirza&backgroundColor=1a5276",
//     tag: "Logistics",
//     tagColor: "#1a5276",
//   },
//   {
//     id: 14,
//     name: "Ruqaiya Jafri",
//     profession: "Event Manager",
//     role: "Events & Programs",
//     joined: "Dec 2023",
//     location: "Mumbai, MH",
//     bio: "Organizes fundraisers, sermons, community events, and awareness drives.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=RuqaiyaJafri&backgroundColor=b7950b",
//     tag: "Events",
//     tagColor: "#b7950b",
//   },
//   {
//     id: 15,
//     name: "Mohsin Haider",
//     profession: "Data Analyst (B.Tech)",
//     role: "Data & Reporting",
//     joined: "Jan 2024",
//     location: "Navi Mumbai, MH",
//     bio: "Tracks beneficiary data, generates reports, and measures foundation impact.",
//     avatar: "https://api.dicebear.com/7.x/personas/svg?seed=MohsinHaider&backgroundColor=117a65",
//     tag: "Data",
//     tagColor: "#117a65",
//   },
// ];

// const Members = () => {
//   const [selected, setSelected] = useState(null);

//   return (
//     <div className="mb-root">
//       <div className="mb-header">
//         <h2 className="mb-title">Our Team Members</h2>
//         <p className="mb-subtitle">
//           Meet the dedicated individuals behind Al-Qaim Welfare Foundation
//         </p>
//       </div>

//       <div className="mb-grid">
//         {DEMO_MEMBERS.map((member) => (
//           <div
//             key={member.id}
//             className={`mb-card ${selected === member.id ? "mb-card-open" : ""}`}
//             onClick={() =>
//               setSelected(selected === member.id ? null : member.id)
//             }
//           >
//             <div className="mb-card-inner">
//               <div className="mb-avatar-wrap">
//                 <img
//                   src={member.avatar}
//                   alt={member.name}
//                   className="mb-avatar"
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=162f06&color=fff&size=100`;
//                   }}
//                 />
//                 <span
//                   className="mb-tag"
//                   style={{ background: member.tagColor }}
//                 >
//                   {member.tag}
//                 </span>
//               </div>

//               <div className="mb-info">
//                 <h3 className="mb-name">{member.name}</h3>
//                 <p className="mb-role">{member.role}</p>
//                 <p className="mb-profession">{member.profession}</p>

//                 {selected === member.id && (
//                   <div className="mb-details">
//                     <p className="mb-bio">{member.bio}</p>
//                     <div className="mb-meta">
//                       <span>📍 {member.location}</span>
//                       <span>🗓 Joined {member.joined}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <span className="mb-chevron">
//                 {selected === member.id ? "▲" : "▼"}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Members;

import React, { useState, useRef, useEffect } from "react";
import {
  collection, getDocs, addDoc, updateDoc, deleteDoc,
  doc, Timestamp, orderBy, query,
} from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import "../css/peoplepanel.css";

const CLOUD_NAME    = "decikvy0b";
const UPLOAD_PRESET = "ij5ifyyw";
const COLLECTION    = "AQWFMembers";

const TAG_COLORS = {
  "Core Team": "#162f06", "Medical":   "#2980b9", "Education": "#e67e22",
  "Finance":   "#27ae60", "Outreach":  "#c0392b", "Creative":  "#1abc9c",
  "PR":        "#2c3e50", "Ration":    "#f39c12", "Legal":     "#6c3483",
  "Welfare":   "#a93226", "Logistics": "#1a5276", "Events":    "#b7950b",
  "Data":      "#117a65", "Admin":     "#555",    "Other":     "#888",
};

const BLANK = () => ({
  name: "", role: "", profession: "", location: "Mumbai, MH",
  joined: new Date().toLocaleDateString("en-US", { month: "short", year: "numeric" }),
  bio: "", photo: "", tag: "Other",
});

// ── seed data written to Firestore only once (if collection is empty) ──
const SEED = [
].map((m) => ({
  ...BLANK(), ...m,
  bio: `Member of Al-Qaim Welfare Foundation.`,
  location: "Mumbai, MH",
  joined: "Jan 2023",
  createdAt: Timestamp.now(),
}));

export default function Members() {
  const [members,   setMembers]   = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [editId,    setEditId]    = useState(null);
  const [showAdd,   setShowAdd]   = useState(false);
  const [newData,   setNewData]   = useState(BLANK());
  const [uploading, setUploading] = useState(false);
  const [search,    setSearch]    = useState("");

  /* ── Fetch from Firestore ── */
  useEffect(() => { fetchMembers(); }, []);

  const fetchMembers = async () => {
    setLoading(true);
    try {
      const q    = query(collection(db, COLLECTION), orderBy("createdAt", "asc"));
      const snap = await getDocs(q);

      if (snap.empty) {
        // seed initial data
        await Promise.all(SEED.map((m) => addDoc(collection(db, COLLECTION), m)));
        const snap2 = await getDocs(q);
        setMembers(snap2.docs.map((d) => ({ id: d.id, ...d.data() })));
      } else {
        setMembers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load members.");
    }
    setLoading(false);
  };

  /* ── Cloudinary upload ── */
  const uploadPhoto = async (file, onDone) => {
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", UPLOAD_PRESET);
    fd.append("public_id", `aqwf/members/${Date.now()}`);
    try {
      const res  = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: fd });
      const data = await res.json();
      if (data.secure_url) { onDone(data.secure_url); toast.success("Photo uploaded!"); }
      else throw new Error(data.error?.message || "Upload failed");
    } catch (e) { toast.error("Photo upload failed: " + e.message); }
    setUploading(false);
  };

  /* ── Save edit to Firestore ── */
  const handleSave = async (id, updated) => {
    try {
      const { id: _id, createdAt, ...data } = updated;
      await updateDoc(doc(db, COLLECTION, id), data);
      setMembers((prev) => prev.map((m) => (m.id === id ? { ...m, ...data } : m)));
      setEditId(null);
      toast.success("Member updated.");
    } catch (err) { toast.error("Save failed."); }
  };

  /* ── Add new member ── */
  const handleAdd = async () => {
    if (!newData.name.trim()) { toast.error("Name is required."); return; }
    try {
      const payload = { ...newData, createdAt: Timestamp.now() };
      const ref = await addDoc(collection(db, COLLECTION), payload);
      setMembers((prev) => [...prev, { id: ref.id, ...payload }]);
      setNewData(BLANK());
      setShowAdd(false);
      toast.success("Member added.");
    } catch (err) { toast.error("Add failed."); }
  };

  /* ── Delete ── */
  const handleDelete = async (id) => {
    if (!window.confirm("Remove this member permanently?")) return;
    try {
      await deleteDoc(doc(db, COLLECTION, id));
      setMembers((prev) => prev.filter((m) => m.id !== id));
      toast.success("Member removed.");
    } catch { toast.error("Delete failed."); }
  };

  const filtered = members.filter((m) =>
    m.name?.toLowerCase().includes(search.toLowerCase()) ||
    m.role?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="pp-root">
      <ToastContainer />

      <div className="pp-header">
        <div>
          <h2 className="pp-title">👥 Members</h2>
          <p className="pp-sub">Team members — saved to Firestore, persists across reloads</p>
        </div>
        <div className="pp-header-actions">
          <input className="pp-search" placeholder="Search members…" value={search} onChange={(e) => setSearch(e.target.value)} />
          <button className="pp-add-btn" onClick={() => setShowAdd(true)}>+ Add Member</button>
        </div>
      </div>

      <div className="pp-count">{loading ? "Loading…" : `${filtered.length} member${filtered.length !== 1 ? "s" : ""}`}</div>

      {/* Add Modal */}
      {showAdd && (
        <div className="pp-modal-bg" onClick={() => setShowAdd(false)}>
          <div className="pp-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="pp-modal-title">Add New Member</h3>
            {/* Photo picker in modal */}
            <ModalPhotoRow
              photo={newData.photo}
              uploading={uploading}
              onUpload={(file) => uploadPhoto(file, (url) => setNewData((p) => ({ ...p, photo: url })))}
            />
            <PersonForm data={newData} onChange={setNewData} />
            <div className="pp-modal-actions">
              <button className="pp-cancel-btn" onClick={() => { setShowAdd(false); setNewData(BLANK()); }}>Cancel</button>
              <button className="pp-save-btn" onClick={handleAdd}>Add Member</button>
            </div>
          </div>
        </div>
      )}

      {/* Grid */}
      {loading ? (
        <div className="pp-loading"><div className="pp-spinner" /><p>Loading members…</p></div>
      ) : (
        <div className="pp-grid">
          {filtered.map((member) => (
            <PersonCard
              key={member.id}
              person={member}
              isEditing={editId === member.id}
              onEdit={() => setEditId(member.id)}
              onCancel={() => setEditId(null)}
              onSave={(updated) => handleSave(member.id, updated)}
              onDelete={() => handleDelete(member.id)}
              uploading={uploading}
              onPhotoUpload={(file) =>
                uploadPhoto(file, (url) => {
                  handleSave(member.id, { ...member, photo: url });
                })
              }
              tagColors={TAG_COLORS}
            />
          ))}
        </div>
      )}
    </div>
  );
}

/* ─────────────────── PersonCard ─────────────────── */
function PersonCard({ person, isEditing, onEdit, onCancel, onSave, onDelete, uploading, onPhotoUpload, tagColors }) {
  const [draft, setDraft] = useState({ ...person });
  const fileRef = useRef();

  useEffect(() => { setDraft({ ...person }); }, [person]);

  return (
    <div className={`pp-card ${isEditing ? "pp-card-editing" : ""}`}>
      {/* Photo */}
      <div className="pp-photo-wrap">
        {draft.photo
          ? <img src={draft.photo} alt={draft.name} className="pp-photo" />
          : <div className="pp-photo-placeholder"><span>👤</span></div>
        }
        {isEditing && (
          <button className="pp-photo-btn" onClick={() => fileRef.current.click()} disabled={uploading}>
            {uploading ? "…" : "📷 Change Photo"}
          </button>
        )}
        <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }}
          onChange={(e) => e.target.files[0] && onPhotoUpload(e.target.files[0])} />
      </div>

      {/* Body */}
      <div className="pp-card-content">
        {isEditing ? (
          <PersonForm data={draft} onChange={setDraft} />
        ) : (
          <div className="pp-card-view">
            <span className="pp-tag" style={{ background: tagColors[person.tag] || "#888" }}>{person.tag}</span>
            <h3 className="pp-name">{person.name || "—"}</h3>
            <p className="pp-role">{person.role}</p>
            <p className="pp-profession">{person.profession}</p>
            <p className="pp-bio">{person.bio}</p>
            <div className="pp-meta-row">
              <span>📍 {person.location}</span>
              <span>🗓 {person.joined}</span>
            </div>
          </div>
        )}
        <div className="pp-card-actions">
          {isEditing ? (
            <>
              <button className="pp-cancel-btn" onClick={onCancel}>Cancel</button>
              <button className="pp-save-btn" onClick={() => onSave(draft)}>Save</button>
            </>
          ) : (
            <>
              <button className="pp-edit-btn" onClick={onEdit}>✏️ Edit</button>
              <button className="pp-delete-btn" onClick={onDelete}>🗑</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────── PersonForm ─────────────────── */
function PersonForm({ data, onChange }) {
  const set = (k, v) => onChange((prev) => ({ ...prev, [k]: v }));
  return (
    <div className="pp-form">
      <div className="pp-form-row">
        <div className="pp-form-field">
          <label>Name *</label>
          <input value={data.name} onChange={(e) => set("name", e.target.value)} placeholder="Full name" />
        </div>
        <div className="pp-form-field">
          <label>Role</label>
          <input value={data.role} onChange={(e) => set("role", e.target.value)} placeholder="Role in foundation" />
        </div>
      </div>
      <div className="pp-form-row">
        <div className="pp-form-field">
          <label>Profession</label>
          <input value={data.profession} onChange={(e) => set("profession", e.target.value)} placeholder="e.g. Doctor (MBBS)" />
        </div>
        <div className="pp-form-field">
          <label>Tag</label>
          <select value={data.tag} onChange={(e) => set("tag", e.target.value)}>
            {Object.keys(TAG_COLORS).map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>
      <div className="pp-form-row">
        <div className="pp-form-field">
          <label>Location</label>
          <input value={data.location} onChange={(e) => set("location", e.target.value)} placeholder="City" />
        </div>
        <div className="pp-form-field">
          <label>Joined</label>
          <input value={data.joined} onChange={(e) => set("joined", e.target.value)} placeholder="e.g. Jan 2023" />
        </div>
      </div>
      <div className="pp-form-field pp-form-full">
        <label>Bio</label>
        <textarea rows={2} value={data.bio} onChange={(e) => set("bio", e.target.value)} placeholder="Short bio…" />
      </div>
    </div>
  );
}

/* ─────────────────── Modal photo row ─────────────────── */
function ModalPhotoRow({ photo, uploading, onUpload }) {
  const ref = useRef();
  return (
    <div className="pp-modal-photo-row">
      <div className="pp-modal-photo-preview">
        {photo
          ? <img src={photo} alt="preview" className="pp-modal-photo-img" />
          : <div className="pp-modal-photo-placeholder"><span>👤</span></div>
        }
      </div>
      <button className="pp-photo-upload-btn" onClick={() => ref.current.click()} disabled={uploading}>
        {uploading ? "Uploading…" : "📷 Upload Photo"}
      </button>
      <input ref={ref} type="file" accept="image/*" style={{ display: "none" }}
        onChange={(e) => e.target.files[0] && onUpload(e.target.files[0])} />
    </div>
  );
}